export default "__VITE_ASSET__00adb465__"